import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Sunrise, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { Empty } from "@/components/common";
import { Markdown } from "@/components/toth/Markdown";
import { fmtDT } from "@/lib/format";
import { cn } from "@/lib/utils";

export const BriefingPanel = () => {
  const [rows, setRows] = useState(null);
  const [sel, setSel] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(async () => {
    const { data } = await api.get("/toth/briefings");
    setRows(data);
    setSel((s) => s || data[0]?.id || null);
  }, []);
  useEffect(() => {
    load();
  }, [load]);
  const gen = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/toth/briefings");
      setSel(data.id);
      await load();
      toast.success("Briefing generato");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  const cur = rows?.find((b) => b.id === sel);
  return (
    <div className="grid gap-4 lg:grid-cols-[260px_1fr]" data-testid="toth-briefing">
      <div className="space-y-2">
        <Button onClick={gen} disabled={busy} className="h-11 w-full rounded-xl font-bold" data-testid="toth-briefing-generate">
          {busy ? <Loader2 className="mr-1 h-4 w-4 animate-spin" /> : <Sunrise className="mr-1 h-4 w-4" />}{busy ? "Toth sta preparando…" : "Genera briefing ora"}
        </Button>
        <p className="text-xs text-muted-foreground">Ogni giorno alle 7:30 Toth prepara automaticamente il briefing sulle tue commesse.</p>
        {rows?.map((b) => (
          <button key={b.id} onClick={() => setSel(b.id)} className={cn("w-full rounded-xl border px-3 py-2 text-left text-sm", b.id === sel ? "border-primary bg-accent" : "bg-white")} data-testid={`toth-briefing-item-${b.id}`}>
            <b>{fmtDT(b.created_at)}</b><span className="block text-xs text-muted-foreground">{b.trigger} · {b.status}</span>
          </button>
        ))}
      </div>
      <div className="card-soft min-h-[300px] p-5 sm:p-6">
        {!rows ? <p className="text-muted-foreground">Caricamento…</p> : !cur ? <Empty text="Nessun briefing ancora disponibile." testid="toth-briefing-empty" /> : <Markdown text={cur.content || "In preparazione…"} testid="toth-briefing-content" />}
      </div>
    </div>
  );
};
